// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { DynamicDialog } from '@advisor-app/components';
import { ModalLinkAccount } from '@advisor-app/features/brokers';
import { CopilotChat } from '@advisor-app/features/copilot/components';
import { BarTrialPeriod } from '@advisor-app/components/bar-trial-period';
import { FreeTrialExpires } from '@advisor-app/features/ui/advices';
import { hubspotChat } from '@shared/ui-kit/utils/hubspot-chat';
import {
  useAppReduxLoader,
  useAppSubscriptions,
  useValidateRegisteredUser,
} from '@advisor-app/hooks';
import TagManager from 'react-gtm-module';
import { useAppSelector } from '@advisor-app/store/store';
import { selectUserData } from '@shared/data-access/slices/user';
import {
  environment,
  isBuildDevelopment,
  isDevelopment,
} from '@shared/environment';

export function App() {
  const location = useLocation();

  const { canUserUseApp, expiration_date } = useAppSubscriptions();

  const user = useAppSelector(selectUserData);

  useAppReduxLoader();

  useValidateRegisteredUser();

  useEffect(() => {
    if (isDevelopment || isBuildDevelopment) return;

    const idHubspotChat = environment.SERVICES.HUBSPOT_CHAT_ID!;

    hubspotChat(idHubspotChat);

    const tagManagerArgs = {
      gtmId: environment.SERVICES.GOOGLE_TAG_MANAGER_ID!,
    };

    TagManager.initialize(tagManagerArgs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <output>
      <FreeTrialExpires
        canUserUseApp={canUserUseApp}
        expirationDate={expiration_date!}
      />

      {!location.pathname.includes('/account') && <BarTrialPeriod />}

      <ModalLinkAccount />

      {user?.email?.includes('@citecsolutions.com') && !isDevelopment && (
        <CopilotChat />
      )}

      <DynamicDialog />
    </output>
  );
}
